import { render } from "./sopdocviewer.vue?vue&type=template&id=22d6bb54&scoped=true"
import script from "./sopdocviewer.vue?vue&type=script&lang=js"
export * from "./sopdocviewer.vue?vue&type=script&lang=js"

import "./sopdocviewer.vue?vue&type=style&index=0&id=22d6bb54&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22d6bb54"]])

export default __exports__